import React from "react"
import PropTypes from "prop-types"
import { Modal } from "ui/Modal"
import { VideoPlayer } from "ui/VideoPlayer"

export const VideoPlayerModal = ({ open, selectedMedia, handleClose }) => (
  <Modal
    open={open}
    onCancel={handleClose}
    width={800}
    centered
    destroyOnClose
    footer={null}
    bodyStyle={{
      maxHeight: "80vh",
      overflow: "auto"
    }}
    style={{
      maxHeight: "90vh",
      overflow: "hidden"
    }}
  >
    {selectedMedia && (
      <VideoPlayer
        src={selectedMedia.url || selectedMedia.file_preview}
        thumbnailUrl={selectedMedia.preview_url || selectedMedia.thumbnail_url || selectedMedia.placeholder_url}
        className="w-full p-3xl"
        autoPlay
        controls
      />
    )}
  </Modal>
)

VideoPlayerModal.propTypes = {
  open: PropTypes.bool.isRequired,
  selectedMedia: PropTypes.shape({
    url: PropTypes.string,
    file_preview: PropTypes.string,
    preview_url: PropTypes.string,
    thumbnail_url: PropTypes.string,
    placeholder_url: PropTypes.string
  }),
  handleClose: PropTypes.func.isRequired
}
